import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { CustomProductBulkTarget } from '../types/customProductBulkActions';
import { unwrapCallableData } from './callableResponse';

type DownloadCustomProductInputsRequest = {
    companyId: string;
} & Partial<CustomProductBulkTarget>;

interface DownloadCustomProductInputsResponse {
    filePath: string;
    bucketName: string;
}

const downloadCustomProductInputs = async (
    companyId: string,
    target?: CustomProductBulkTarget,
): Promise<DownloadCustomProductInputsResponse> => {
    const downloadCustomProductInputsCallable =
        httpsCallable<DownloadCustomProductInputsRequest, any>(
            functions,
            'download_custom_product_inputs',
        );
    const result = await downloadCustomProductInputsCallable({ companyId, ...target });

    return unwrapCallableData<DownloadCustomProductInputsResponse>(result.data);
};

export { downloadCustomProductInputs };
